import { request } from "../../apis";
import { getCurrency, getUserCurrency } from "../../plugins/utils";

const userCurrency = getUserCurrency();
const currentCurrency = getCurrency();

export const apiGetUserInfo = (params) =>
  request("get", `/${userCurrency}/agent/info`, params, true);

//balance
export const apiGetAgentWallet = ({ params }) =>
  request("get", `/${currentCurrency}/agent/wallet`, params, true);

//export member
export const apiPostFileManager = (params) =>
  request("post", `/${currentCurrency}/agent/file/manager`, params, true);

//transfer
export const apiPutWithdraw = (params) =>
  request("put", `/${currentCurrency}/agent/withdraw`, params, true);
